import React from 'react';
import { Braces, Code2, Repeat, Box, Info } from 'lucide-react';

const ApiMappingWizard = ({ data = {}, setData }) => {
  
  const handleToggle = (option) => {
    setData({
      ...data,
      apiOptions: { ...data.apiOptions, [option]: !data.apiOptions[option] }
    });
  };

  return (
    <div className="animate-in fade-in slide-in-from-top-4 duration-500 text-left">
      
      {/* NOTA DEL EXPERTO EN INTEGRACIÓN */}
      <div className="bg-amber-900/10 border-l-4 border-amber-600 p-6 mb-10 rounded-r-3xl flex gap-4 items-start shadow-sm">
        <div className="bg-amber-600 p-2 rounded-xl text-white shadow-lg shadow-amber-500/20 shrink-0">
            <Braces size={20}/>
        </div>
        <div>
            <p className="text-[11px] text-amber-800 font-black uppercase tracking-widest mb-1 italic">API Integration Guide:</p>
            <p className="text-[11px] text-slate-600 leading-relaxed font-medium">
                Esta herramienta convierte una respuesta **JSON** en estructuras de datos ABAP (**TYPES**). 
                Genera automáticamente la lógica de deserialización utilizando la clase estándar <code className="bg-amber-100 px-1 rounded text-amber-700">/UI2/CL_JSON</code>. 
                Es ideal para integraciones vía REST/API donde se requiere convertir nombres de campos de <code className="bg-amber-100 px-1 rounded text-amber-700">camelCase</code> a <code className="bg-amber-100 px-1 rounded text-amber-700">SNAKE_CASE</code> de forma automática.
            </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10">
        
        {/* CONFIGURACIÓN DE LA ESTRUCTURA */}
        <div className="bg-[#0F172A] p-8 rounded-[32px] text-white shadow-xl italic border-b-4 border-amber-500 text-left">
          <label className="text-[10px] font-black text-amber-400 uppercase block mb-6 border-b border-slate-800 pb-2 flex items-center gap-2 text-left">
            <Box size={14}/> ABAP Target Structure
          </label>
          
          <div className="space-y-5 text-left">
            <div className="text-left">
              <label className="text-[9px] font-bold text-slate-500 uppercase block mb-1">Nombre de la Estructura (TY_...)</label>
              <input type="text" className="w-full p-3 bg-slate-800 border-none rounded-xl text-xs font-mono uppercase focus:ring-2 focus:ring-amber-500 outline-none text-amber-200" 
                placeholder="TY_API_RESPONSE" value={data.apiStructName || ''} onChange={e => setData({...data, apiStructName: e.target.value})} />
            </div>

            <div className="text-left">
              <label className="text-[9px] font-bold text-slate-500 uppercase block mb-1">Método de Deserialización</label>
              <select className="w-full p-3 bg-slate-800 border-none rounded-xl text-xs font-bold outline-none focus:ring-2 focus:ring-amber-500" 
                value={data.apiMethod || 'DESERIALIZE'} onChange={e => setData({...data, apiMethod: e.target.value})}>
                <option value="DESERIALIZE">/UI2/CL_JSON=>DESERIALIZE</option>
                <option value="GENERATE">Generación de Tipos Dinámicos</option>
                <option value="XSLT">Transformación XSLT (XML/JSON)</option>
              </select>
            </div>
          </div>
        </div>

        {/* REGLAS DE MAPEADO */}
        <div className="bg-[#0F172A] p-8 rounded-[32px] text-white shadow-xl italic border-b-4 border-amber-500 text-left">
          <label className="text-[10px] font-black text-amber-400 uppercase block mb-6 border-b border-slate-800 pb-2 flex items-center gap-2 text-left">
                <Repeat size={14}/> Mapping Rules
            </label>
            <div className="space-y-4 text-left">
                <label className="flex items-center justify-between group cursor-pointer p-3 bg-slate-50 rounded-xl hover:bg-amber-50 transition-all">
                    <span className="text-[10px] font-bold text-slate-600 uppercase">Pretty Name (Camel to Snake)</span>
                    <input type="checkbox" className="w-4 h-4 rounded border-slate-300 text-amber-600 focus:ring-0" 
                        checked={data.apiOptions?.prettyName || false} onChange={() => handleToggle('prettyName')} />
                </label>

                <label className="flex items-center justify-between group cursor-pointer p-3 bg-slate-50 rounded-xl hover:bg-amber-50 transition-all">
                    <span className="text-[10px] font-bold text-slate-600 uppercase">Manejar Atributos Vacíos</span>
                    <input type="checkbox" className="w-4 h-4 rounded border-slate-300 text-amber-600 focus:ring-0" 
                        checked={data.apiOptions?.skipEmpty || false} onChange={() => handleToggle('skipEmpty')} />
                </label>

                <label className="flex items-center justify-between group cursor-pointer p-3 bg-slate-50 rounded-xl hover:bg-amber-50 transition-all">
                    <span className="text-[10px] font-bold text-slate-600 uppercase">Generar Lógica de Respuesta</span>
                    <input type="checkbox" className="w-4 h-4 rounded border-slate-300 text-amber-600 focus:ring-0" 
                        checked={data.apiOptions?.genLogic || false} onChange={() => handleToggle('genLogic')} />
                </label>

                <div className="pt-2">
                    <div className="flex items-center gap-2 text-amber-600 mb-2">
                        <Code2 size={16}/>
                        <span className="text-[10px] font-black uppercase tracking-tight">Parser Engine 2.0</span>
                    </div>
                    <p className="text-[9px] text-slate-400 font-medium leading-tight">
                        Se analizarán arrays y objetos anidados para crear tipos de tabla (`TT_...`) y estructuras anidadas automáticamente.
                    </p>
                </div>
            </div>
        </div>

      </div>
    </div>
  );
};

export default ApiMappingWizard;